<div class="mb-4">
  <app-button [text]="'<'" [matButtonAparence]="'tonal'" [href]="'/'+backUrl()" type="button"></app-button>
</div>
<app-titledescription [title]="'Materias'" [description]="'Aca se muestra el listado de material del siguiente plan:'"></app-titledescription>
<div class="mb-4">
  <p><strong>Código:</strong> {{ planData?.codigo }}</p>
  <p><strong>Descripción:</strong> {{ planData?.descripcion }}</p>
  <p><strong>Nivel:</strong> {{ planData?.nivel?.descripcion }}</p>
  <p><strong>Modalidad:</strong> {{ planData?.modalidad?.descripcion }}</p>
</div>
<app-table
	[columnsNames]="columnNames"
	[dataFetch]="dataFetch"
	[totalItems]="totalItems"
	[actions]="actions"
	[apiService]="apiService"
  [labelFilter]="'Descripcion'"
	[pagination]="true"
	[filterable]="true"
	[pageSize]="take"
	(fetchAgain)="fetchData($event.options, $event.ignoreCache)"
  [actionsDeletedItems]="actionsDeletedItems"
  [paginateOptions]="paginateOptions"
	[pageIndex]="pageIndex"
></app-table>
